export default {
  mainMenu: [],
  screenLayouts: [],
  flashMessage: undefined,
  adminMode: undefined,
  menu: "main",
  previousMenu: undefined,
  referrer: "/",
  caseWorkMenu: [],
  configMenu: [],
  caseMenu: [],
  grantedPermissions: [],
  hideDragIcons: false,
  loadingActiveUser: false,
  loadingUsers: false,
  loadingSelectedUser: false,
  loadingTeams: false,
  loadingSelectedTeam: false,
  loading: false,
  lastCaseContainerPath: [],
  commsEnabled: false,
  metricsEnabled: false,
  clipboard: {
    commsMessage: null
  },
  pageTitle: 'Caseblocks',
  lastVisitedInboxId: undefined,
  menuColor: 'rgb(29,48,62)',
  whiteTheme: false,
  caseViewerObserver: undefined,
  keepMainMenuExpanded: true,
  showMessageSidePanel: false,
  showDocumentSidePanel: false,
  sidePanelType: 'message',
  sidePanelContents: undefined,
  sidePanelExpanded: true,
  emailWindow: {
    emailWindowToggled: false,
    allParticipants: [],
    currentCase: undefined,
    allBodyTemplates: [],
    replyMode: false,
    currentRecipients: [],
    currentRecipientsCc: [],
    currentRecipientsBcc: [],
    conversationId: undefined,
    title: "New Message",
    conversationSubject: undefined
  },
  documentWindow: {
    field: undefined,
    fileAttachment: undefined
  }
}
